/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Fdc_ResultsInputs */

const en_fix_fdc_results = /** @type {(inputs: Fix_Fdc_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USDA foods`)
};

const de_fix_fdc_results = /** @type {(inputs: Fix_Fdc_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USDA-Lebensmittel`)
};

/**
* | output |
* | --- |
* | "USDA foods" |
*
* @param {Fix_Fdc_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_fdc_results = /** @type {((inputs?: Fix_Fdc_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Fdc_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_fdc_results(inputs)
	return en_fix_fdc_results(inputs)
});